/**
 * Allow only absolute http(s) URLs for href attributes.
 *
 * Blocks javascript: / data: / vbscript: XSS, and — because it parses with no
 * base — also rejects protocol-relative values like `//evil.com` and bare
 * words like `foo`, which previously resolved against window.location.origin
 * and turned a candidate-supplied portfolio field into a live external link or
 * a same-origin in-app link.
 *
 * Returns null when the value is missing, relative or unsafe.
 */
export function safeHttpUrl(value) {
  if (value == null) return null;
  const raw = String(value).trim();
  if (!raw) return null;
  try {
    const parsed = new URL(raw);
    if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') return null;
    return parsed.href;
  } catch {
    return null;
  }
}
